import { first_non_empty_number } from "./esigning_setup_helpers";
import {
    build_preview_request_payload,
    get_resolved_template_document_id,
    request_preview_with_retry
} from "./esigning_setup_preview_request_helpers";
import {
    build_preview_error_result,
    get_missing_context_result,
    resolve_preview_result
} from "./esigning_setup_preview_result_helpers";

function resolve_preview_context(vm) {
    const template_document_id = first_non_empty_number(
        vm.selected_template?.template_document_id,
        vm.selected_template?.template_id
    );
    const template_entity_type_id = first_non_empty_number(
        vm.selected_template?.template_document_entity_type_id,
        vm.selected_template?.template_document_entity_type
    );
    const application_id = vm.route_application_id;

    const preview_context = {
        application_id,
        template_document_id,
        template_entity_type_id
    };
    return preview_context;
}

async function request_resolved_preview_result(vm, resolved_template_document_id, request_payload) {
    const preview_result = await request_preview_with_retry(
        vm,
        resolved_template_document_id,
        request_payload,
        build_preview_error_result
    );
    return resolve_preview_result(vm, preview_result);
}

export function create_populated_document_preview(vm) {
    const { application_id, template_document_id, template_entity_type_id } = resolve_preview_context(vm);

    const missing_context_result = get_missing_context_result(
        application_id,
        template_entity_type_id
    );
    if (missing_context_result) {
        return Promise.resolve(missing_context_result);
    }

    const request_payload = build_preview_request_payload(
        application_id,
        template_entity_type_id
    );
    const resolved_template_document_id = get_resolved_template_document_id(
        template_entity_type_id,
        template_document_id
    );

    return request_resolved_preview_result(
        vm,
        resolved_template_document_id,
        request_payload
    ).catch((error) => {
        const error_message =
            error?.message || "Failed to load the populated document preview.";
        vm.show_error(error_message);
        return build_preview_error_result(error_message);
    });
}